import StudioElettrofisiologicoEdit from "./components/StudioElettrofisiologicoEdit.vue";
import StudioElettrofisiologicoView from "./components/StudioElettrofisiologicoView.vue";
import StudioElettrofisiologicoList from "./components/StudioElettrofisiologicoList.vue";

export default {
    StudioElettrofisiologicoEdit,
    StudioElettrofisiologicoView,
    StudioElettrofisiologicoList,
};
